import { useEffect } from 'react'
import './footer.css';
import { HashLink as Link } from 'react-router-hash-link';
import 'boxicons/css/boxicons.min.css'
export default function Footer() {

  useEffect(() => {

    function isFooterVisible() {
      const footer = document.querySelector('footer');
      const footerRect = footer.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      return (
        footerRect.top >= 0 &&
        footerRect.top < windowHeight
      );
    }
    const socials = document.querySelector('.social-links')
    document.addEventListener('scroll', function () {
      if (isFooterVisible() && socials) {
        socials.classList.remove('fixed-socials')

      }
      else {
        if (socials) {
          socials.classList.add('fixed-socials')
        }
      }
    })

  }, [])
  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -80;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });

  }
  return (
    <footer id="footer">
      <div className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6 footer-contact">
              <h3>Surrealance</h3>
              <p>

                <strong>Phone:</strong> +1 469-638 3505
                <br />
                <strong>Email:</strong> info@surrealance.com
                <br />
              </p>
            </div>
            <div className="col-lg-3 col-md-6 footer-links">
              <h4>Links</h4>
              <ul>
                <li>
                  <i className="bx bx-chevron-right" /> <Link to="/#">Home</Link>
                </li>
                <li>
                  <i className="bx bx-chevron-right" /> <Link to="/#about" scroll={el => scrollWithOffset(el)}>About us</Link>
                </li>
                <li>
                  <i className="bx bx-chevron-right" /> <Link to="/#services" scroll={el => scrollWithOffset(el)}>Services</Link>
                </li>
                <li>
                  <i className="bx bx-chevron-right" />{" "}
                  <Link to="/#industry" scroll={el => scrollWithOffset(el)}>Industries</Link>
                </li>
                <li>
                  <i className="bx bx-chevron-right" />{" "}
                  <Link to="/#contact" scroll={el => scrollWithOffset(el)}>Contact</Link>
                </li>
                <li>
                  <i className="bx bx-chevron-right" />{" "}
                  <Link to="/affiliates#">Affiliates</Link>
                </li>
              </ul>
            </div>
            {/* <div className="col-lg-3 col-md-6 footer-links">
            <h4>to be removed</h4>
            <ul>
              <li>
                <i className="bx bx-chevron-right" /> <Link to="/#services" scroll={el => scrollWithOffset(el)}>Services</Link>
              </li>
              <li>
                <i className="bx bx-chevron-right" />{" "}
                <Link to="/#services" scroll={el => scrollWithOffset(el)}>Industries</Link>
              </li>
              <li>
                <i className="bx bx-chevron-right" />{" "}
                <Link to="/#services" scroll={el => scrollWithOffset(el)}>Product Management</Link>
              </li>
              <li>
                <i className="bx bx-chevron-right" /> <Link to="/#services" scroll={el => scrollWithOffset(el)}>Marketing</Link>
              </li>
              <li>
                <i className="bx bx-chevron-right" />{" "}
                <Link to="/#services" scroll={el => scrollWithOffset(el)}>Graphic Design</Link>
              </li>
            </ul>
          </div> */}
            <div className="col-lg-3 col-md-6 footer-links">
              <h4>Our Social Networks</h4>

              <div className="social-links mt-3 fixed-socials">
                <a href="https://twitter.com/Surrealance" target="_blank" className="twitter">
                  <i className="bx bxl-twitter" />
                </a>
                <a href="https://www.facebook.com/Surrealance" target="_blank" className="facebook">
                  <i className="bx bxl-facebook" />
                </a>
                <a href="https://www.instagram.com/surrealance/" target="_blank" className="instagram">
                  <i className="bx bxl-instagram" />
                </a>

                <a href="https://www.linkedin.com/company/surrealance" target="_blank" className="linkedin">
                  <i className="bx bxl-linkedin" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container footer-bottom clearfix">
        <div className="copyright">
          <div style={{ marginRight: "4px" }}>
            © Copyright{" "}
            <strong>
              <span>Surrealance</span>
            </strong>
            . All Rights Reserved
          </div>
          <div>
            <span> | </span>
            <Link className='copyright-link' to="/privacy#">Privacy Policy</Link>
            <span> | </span>
            <Link className='copyright-link' to="/service-agreement#">Service Agreement</Link>
            <span> | </span>
            <Link className='copyright-link' to="/faqs#">FAQ</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
